import * as Sentry from "@sentry/react";

Sentry.init({
  enabled: import.meta.env.VITE_SENTRY_ENABLED === "true",
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_BS_ENV,
  release: import.meta.env.VITE_APP_BUNDLE_VERSION,

  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  tracesSampleRate: 1.0,
  sendDefaultPii: false,

  _experiments: {
    enableLogs: true,
  },

  integrations: [
    Sentry.replayIntegration({
      maskAllText: true,
      maskAllInputs: true,
      blockAllMedia: true,
    }),
    Sentry.browserTracingIntegration(),
    Sentry.httpClientIntegration(),
    Sentry.httpContextIntegration(),
    Sentry.replayCanvasIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ['error', 'warn'] })
  ],
});
